/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import { useTeamAppConfig } from '../../hooks/teamApp';
import { useTeam, useTeamLogo } from '../../hooks/team';
import SingleTeamAppUI from './SingleTeamAppUI';

function SingleTeamApp({ team }) {
  const [teamAppConfig] = useTeamAppConfig(team.abbrv);
  const [teamDetails] = useTeam(team.abbrv);
  const [logo] = useTeamLogo(teamDetails?.abbrv, {
    logoImageUrl: teamDetails?.logoImageUrl,
    height: 100,
  });

  if (!teamAppConfig || !teamDetails) {
    return null;
  }

  return (
    <SingleTeamAppUI
      team={team}
      teamDetails={teamDetails}
      title={team.name}
      logo={logo}
      logoAlt={team.abbrv}
      teamAppConfig={teamAppConfig}
    />
  );
}
export default SingleTeamApp;
